import { URLs } from '.'
import * as pages from '../pages'

export const memberUrls: URLs = {
  login: {
    urls: {
      default: '/my-srprs/login',
      nl: '/my-srprs/inloggen',
      be: '/my-srprs/inloggen',
      dk: '/min-srprs/login',
    },
    component: pages.Login,
  },
  login_reset: {
    urls: {
      default: '/my-srprs/login/:reset_token',
      nl: '/my-srprs/inloggen/:reset_token',
      be: '/my-srprs/inloggen/:reset_token',
      dk: '/min-srprs/login/:reset_token',
    },
    component: pages.Login,
  },
  logout: {
    urls: {
      default: '/my-srprs/logout',
      nl: '/my-srprs/afmelden',
      be: '/my-srprs/afmelden',
      dk: '/min-srprs/logout',
    },
    component: pages.Logout,
    auth: true,
  },

  register: {
    urls: { default: '/register/:token', dk: '/registrer/:token' },
    component: pages.Register,
  },

  member: {
    urls: {
      default: '/my-srprs/my-trips',
      nl: '/my-srprs/mijn-trips',
      be: '/my-srprs/mijn-trips',
      dk: '/min-srprs/mine-trips',
    },
    component: pages.Member,
    auth: true,
  },
  member_wallet: {
    urls: { default: '/my-srprs/wallet', dk: '/min-srprs/wallet' },
    component: pages.MemberWallet,
    auth: true,
  },
  member_info: {
    urls: {
      default: '/my-srprs/my-details',
      nl: '/my-srprs/mijn-gegevens',
      be: '/my-srprs/mijn-gegevens',
      dk: '/min-srprs/mine-detaljer',
    },
    component: pages.MemberInfo,
    auth: true,
  },
  member_settings: {
    urls: {
      default: '/my-srprs/settings',
      nl: '/my-srprs/instellingen',
      be: '/my-srprs/instellingen',
      dk: '/min-srprs/indstillinger',
    },
    component: pages.MemberSettings,
    auth: true,
  },
}

export const pageNames = Object.keys(memberUrls)
